<template>
  <div class="flex align-center move-list-ce-table-row">
    <div class="table-column">{{ crossing.crossing_day }}</div>
    <div class="table-column">{{ crossing.crossing_hour }}</div>
    <div class="table-column">{{ crossing.contract_tag }}</div>
    <div class="table-column">{{ crossing.economic_number }}</div>
    <div class="table-column">{{ crossingType }}</div>
    <div class="table-column">{{ isManualCrossing }}</div>
    <div class="table-column">{{ crossing.amount }}</div>
    <div class="table-column">{{ crossing.previous_balance }}</div>
    <div class="table-column">{{ crossing.current_balance }}</div>
  </div>
</template>

<script>
export default {
  name: 'MoveListCeTableRow',
  props: {
    crossing: {
      type: Object,
      required: true
    }
  },
  computed: {
    crossingType () {
      switch (this.crossing.type) {
        case 'crossing':
          return 'Cruce'
        case 'recharge':
          return 'Recarga'
        case 'refund':
          return 'Reembolso'
        case 'web_recharge':
          return 'Recarga web'
        case 'modify':
          return 'Modificación'
        default:
          return 'Cruce'
      }
    },
    isManualCrossing () {
      return this.crossing.manual_crossing ? 'Sí' : 'No'
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/constants";

.move-list-ce-table-row {
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid $grey;
  }
}

.table-column {
  text-align: center;
  margin: 0.75rem 0;
  min-width: 6rem;
  width: calc(100% / 9);
}

@media (max-width: 60rem) {
  .move-list-ce-table-row {
    &:not(:last-child) {
      border-bottom: none;
    }
  }

  .table-column {
    font-size: 0.75rem;
  }
}
</style>
